// Cookie-consent state, shared across app.offerflow.pro AND offerflow.pro.
//
// Subdomains are separate origins, so localStorage can't be shared between them.
// We persist consent in a cookie scoped to the parent domain (.offerflow.pro),
// which BOTH app.offerflow.pro and offerflow.pro can read — so a choice made on
// one applies to the other.

export type Consent = 'granted' | 'denied';

export const CONSENT_COOKIE = 'offerflow_cookie_consent';
const MAX_AGE = 365 * 24 * 60 * 60; // 1 year

const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const domainAttr = isLocalhost ? '' : '; Domain=.offerflow.pro; Secure';

export function getConsent(): Consent | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(
    new RegExp('(?:^|; )' + CONSENT_COOKIE + '=([^;]+)')
  );
  const value = match ? decodeURIComponent(match[1]) : null;
  return value === 'granted' || value === 'denied' ? value : null;
}

export function setConsent(value: Consent): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${CONSENT_COOKIE}=${value}; Path=/; Max-Age=${MAX_AGE}; SameSite=Lax${domainAttr}`;
  applyConsent(value);
}

// Reflect the choice into Google Analytics (react-ga4). The `ga-disable-<id>`
// flag is honoured by gtag.js; the banner additionally re-runs initGA() on
// accept so analytics starts immediately.
export function applyConsent(value: Consent): void {
  const id = process.env.REACT_APP_GA_ID;
  if (id) {
    (window as unknown as Record<string, unknown>)[`ga-disable-${id}`] = value !== 'granted';
  }
}
